import PasswordCriteria from "./PasswordCriteria";

export default PasswordCriteria;
